import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CtaSection = () => (
  <section className="relative py-28 lg:py-36 overflow-hidden bg-gradient-to-b from-white to-blue-50" data-testid="final-cta-section">
    <div className="lp-orb w-[700px] h-[450px] bg-sky-300/50 left-1/2 -translate-x-1/2 top-1/4" />
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="relative z-10 max-w-3xl mx-auto px-5 text-center"
    >
      <img src="/brand/fmark-512.png" alt="" className="h-16 w-16 object-contain mx-auto mb-8" />
      <h2 className="lp-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-[#0b1530]">
        Ready to command
        <br />
        <span className="lp-gradient-text">your warehouse?</span>
      </h2>
      <p className="mt-7 text-base md:text-lg text-slate-600 leading-relaxed max-w-md mx-auto">
        Get a guided walkthrough of FulfillFlow tailored to your 3PL operation.
      </p>
      <div className="mt-11 flex items-center justify-center gap-5 flex-wrap">
        <Link
          to="/contact"
          className="group inline-flex items-center gap-2.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-base md:text-lg font-semibold px-9 py-4 transition-colors shadow-xl shadow-blue-600/30"
          data-testid="final-cta-demo"
        >
          Request a Demo
          <ArrowRight size={19} strokeWidth={2} className="transition-transform group-hover:translate-x-1" />
        </Link>
        <Link
          to="/login"
          className="text-base font-medium text-slate-600 hover:text-blue-600 transition-colors underline underline-offset-4"
          data-testid="final-cta-signin"
        >
          Already a partner? Sign in
        </Link>
      </div>
    </motion.div>
  </section>
);
